export var arrays = {
    join,
}

export function join(separator = ' ', vals) {
    return vals.filter(str => !!str).join(separator);
}